export enum ToggleButtonType {
    ICON = 'Icon',
    TEXT = 'Text',
    ICON_TEXT = 'IconText'
}

export enum ToggleButtonIconStyle {
    ADD_REMOVE = 'AddRemvove'
}